// Fonction pour obtenir les données des variants pour un slide
function getVariantData(slideElement) {
    // Prendre le premier script JSON qu'on trouve dans le slide (ils sont tous identiques)
    const scriptElement = slideElement.querySelector('script[type="application/json"]');
    return scriptElement ? JSON.parse(scriptElement.textContent) : null;
}

// Fonction pour mettre à jour l'ID du variant sélectionné
function updateVariantId(selectElement) {
    const slideElement = selectElement.closest('.splide__slide');
    if (!slideElement) return;

    const variantData = getVariantData(slideElement);
    if (!variantData) return;

    const variantSelects = slideElement.querySelectorAll('.mm-product-form-variant-select select');
    if (!variantSelects.length) return;
    
    // Créer un tableau des options sélectionnées
    const selectedOptions = Array.from(variantSelects).map(select => select.value);
    
    // Trouver le variant correspondant aux options sélectionnées
    const selectedVariant = variantData.find(variant => 
        variant.options.every((option, index) => option === selectedOptions[index])
    );
    
    if (selectedVariant) {
        // Mettre à jour l'ID du variant dans le formulaire
        const form = slideElement.querySelector('.mm-slider-add-to-cart-form');
        if (form) {
            const variantInput = form.querySelector('.product-variant-id');
            if (variantInput) {
                variantInput.value = selectedVariant.id;
                console.log('Variant ID mis à jour:', selectedVariant.id);
            }
        }
    }
}

// Initialiser les écouteurs d'événements pour les sélecteurs de variants
function initVariantSelectors() {
    const variantSelects = document.querySelectorAll('.mm-product-form-variant-select select');
    console.log('Nombre de sélecteurs de variants trouvés:', variantSelects.length);
    
    variantSelects.forEach(select => {
        select.addEventListener('change', (event) => {
            console.log('Changement de variant détecté');
            updateVariantId(event.target);
        });
    });
}

// Initialiser la gestion du formulaire d'ajout au panier
function initAddToCartForms() {
    const forms = document.querySelectorAll('.mm-slider-add-to-cart-form');
    console.log('Nombre de formulaires trouvés:', forms.length);
    
    forms.forEach(form => {
        form.addEventListener('submit', function(event) {
            event.preventDefault();
            console.log('Soumission du formulaire détectée');
            
            const formData = new FormData(form);
            const variantId = formData.get('id');
            console.log('Tentative d\'ajout du variant:', variantId);
            
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: 1
                    }]
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Produit ajouté:', data);
                // Ouvrir et rafraîchir le panier
                if (typeof mmOpenAndRefreshCart === 'function') {
                    mmOpenAndRefreshCart();
                }
            })
            .catch(error => {
                console.error('Erreur lors de l\'ajout au panier:', error);
                alert('Une erreur est survenue lors de l\'ajout au panier');
            });
        });
    });
}

// Fonction d'initialisation principale
function initSliderFunctionality() {
    console.log('Initialisation du slider...');
    initVariantSelectors();
    initAddToCartForms();
}

// S'assurer que le DOM est chargé avant d'initialiser
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSliderFunctionality);
} else {
    initSliderFunctionality();
} 